import { render, staticRenderFns } from "./slider.vue?vue&type=template&id=4435084d&scoped=true&"
import script from "./slider.vue?vue&type=script&lang=js&"
export * from "./slider.vue?vue&type=script&lang=js&"
import style0 from "./slider.vue?vue&type=style&index=0&id=4435084d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4435084d",
  null
  
)

export default component.exports